/** 客服发礼包：0 可发送，1 已发送 */
export const CS_SEND_STATUS = {
  CAN_SEND: 0,
  SENT: 1,
} as const
